import { calculateSectorPath } from "@utils/calculateSectorPath";
import { FC } from "react";
import styles from "../Profile.module.scss";

export interface IPortfolioItem {
    backgroundColor: string;
    name: string;
    tonPrice: number;
    usdPrice: number;
    jettonMasterAddress: string;
    symbol: string;
    image: string;
    guid: string;
    balance: number;
    walletGuid: string;
    decimals: number;
}

interface Props {
    sortedPortfolioItems: IPortfolioItem[];
    portfolioItems: IPortfolioItem[];
    currentPortfolioItem: number;
    setCurrentPortfolioItem: (value: number) => void;
}

const Balance: FC<Props> = ({
    sortedPortfolioItems,
    portfolioItems,
    currentPortfolioItem,
    setCurrentPortfolioItem,
}) => {
    return sortedPortfolioItems?.length > 0 ? (
        <div className={styles.portfolioContent}>
            <div className={styles.items}>
                {sortedPortfolioItems.map(({ name, backgroundColor, tonPrice }, i) => (
                    <div onMouseEnter={() => setCurrentPortfolioItem(i)} key={name} className={styles.item}>
                        <div className={styles.name}>
                            <span style={{ color: backgroundColor, backgroundColor }} className={styles.dot}></span>
                            <span>{name}</span>
                        </div>
                        <div className={styles.value}>
                            <span>{tonPrice?.toFixed(2)} TON</span>
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.circle}>
                <div className={styles.circleMain}>
                    <span className={styles.circleName}>
                        <img
                            width={24}
                            height={24}
                            src={sortedPortfolioItems[currentPortfolioItem].image}
                            alt=""
                            onError={(e) => {
                                const jettonFallback = "/images/jettonFallback.svg";
                                if ((e.target as HTMLImageElement).src !== jettonFallback) {
                                    (e.target as HTMLImageElement).src = jettonFallback;
                                }
                            }}
                        />
                        <span>{sortedPortfolioItems[currentPortfolioItem].name}</span>
                        <span className={styles.circlePercents}>
                            {Math.round(
                                100 /
                                    (portfolioItems.reduce((acc, item) => acc + item.tonPrice, 0) /
                                        sortedPortfolioItems[currentPortfolioItem].tonPrice),
                            )}
                            %
                        </span>
                    </span>
                </div>
                <div className={styles.circleCount}></div>
                <div className={styles.circleDollars}>
                    ~ ${sortedPortfolioItems[currentPortfolioItem].usdPrice?.toFixed(2)}
                </div>
                <div className={styles.circleItems}>
                    <div className={styles.circleItem}>
                        <svg width="490" height="400" viewBox="0 -15 200 200">
                            {sortedPortfolioItems.map(({ backgroundColor, name }, index) => (
                                <path
                                    color={backgroundColor}
                                    onMouseEnter={() => setCurrentPortfolioItem(index)}
                                    key={name}
                                    d={calculateSectorPath(
                                        portfolioItems,
                                        index,
                                        document.body.offsetWidth < 768 ? 60 : 106,
                                    )}
                                    fill={backgroundColor}
                                />
                            ))}
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default Balance;
